module.exports = "/_next/static/images/b5b9dc97b727691e9b74ba44f7731c2b-woman-holding-card-smiling@0.5x.jpg";